export default __webpack_public_path__ + "static/mugshot-small-f1a532e5d8d985a0d62b617fa2ccc726.jpg";